import React from 'react';

const FeatureFlagContext = React.createContext({ isEnabled: false });

export function useFeatureFlagContext() {
  return React.useContext(FeatureFlagContext);
}

export default FeatureFlagContext;
